"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CMETip = exports.DelayMin15Tip = void 0;
var react_1 = __importDefault(require("react"));
require("./index.less");
/**
 * 中金所延时提示
 * @returns
 */
function DelayMin15Tip() {
    return react_1.default.createElement("div", { className: "txbj_delaytip" },
        react_1.default.createElement("span", null, "\u6E29\u99A8\u63D0\u793A\uFF1A\u5F53\u524D\u5217\u8868\u6570\u636E\u5EF6\u65F615\u5206\u949F"),
        "\u00A0",
        react_1.default.createElement("a", { href: "https://zqhd.eastmoney.com/Html/aghd/pc/20171017/activity1.html?tz=webtg_l1_act_qqgs01_01_01_01_0", target: "_blank" }, "\u4E0B\u8F7DAPP\u67E5\u770B\u5B9E\u65F6\u884C\u60C5"));
}
exports.DelayMin15Tip = DelayMin15Tip;
/**
 * CME行情展示合规提示
 * @returns
 */
function CMETip() {
    var loginlink = "https://passport2.eastmoney.com/pub/login?backurl=".concat(encodeURIComponent(window.location.href));
    return react_1.default.createElement("div", { className: "txbj_delaytip" },
        react_1.default.createElement("span", null,
            "\u6E29\u99A8\u63D0\u793A\uFF1A\u6839\u636E\u4EA4\u6613\u6240\u5408\u89C4\u8981\u6C42\uFF0C\u7528\u6237",
            react_1.default.createElement("a", { href: loginlink, target: "_blank" }, "\u767B\u5F55"),
            "\u540E\u624D\u53EF\u67E5\u770B\u5168\u90E8\u884C\u60C5\u6570\u636E"));
}
exports.CMETip = CMETip;
